module.exports = __webpack_public_path__ + "static/media/bigFatWedding.5dac0b39.jpg";